<template>
  <el-tabs class="group_4" v-model="activeTab" type="border-card" style="margin-top:10px">
    <el-tab-pane label="手机号登录" name="login">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'login' }">手机号登录</div>
      </template>
      <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
        <el-form-item prop="phone">
          <el-input v-model="loginForm.phone" placeholder="请输入手机号"
            style="width:88%;margin-left:35px;height:60px;margin-top:40px;">
            <template #prepend>+86</template>
            <template #append>
              <span style="cursor:pointer;" @click="sendSmsCodeLogin()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发送验证码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="loginForm.email" class="email_login" placeholder="请输入验证码"
            style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
            <template #append>
              <span style="cursor:pointer;" @click="loginEmail()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;登录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="group_8 flex-row justify-between">
        <router-link to="/store/entry/loginQRCode">
          <div class="group_9 flex-row">
            <img class="image_1" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG42243e09cea88a3e712bd40184d8b368.png" />
            <span class="text_10">微信登录</span>
          </div>
        </router-link>
        <router-link to="/store/entry/loginPwd">
          <div class="group_10 flex-row">
            <span class="text_11">账号密码登录</span>
            <img class="label_1" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG11bb19dcf44a46184ba4a4b6dda141f9.png" />
          </div>
        </router-link>
      </div>
      <router-link to="/store/entry/forgottenPwd">
        <div class="group_11 flex-row">
          <span class="text_12">忘记密码</span>
          <img class="label_2" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG6c0fa38108e4c2ad2866cfc5dfcc6b7f.png" />
        </div>
      </router-link>
    </el-tab-pane>
    <el-tab-pane label="注册" name="signup">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'signup' }">注册</div>
      </template>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"
            style="width:88%;margin-left:35px;height:60px;margin-top:40px;">
            <template #prepend>+86</template>
            <template #append>
              <span style="cursor:pointer;" @click="sendSmsCodeRegister()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发送验证码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="registerForm.email" class="email_signup" placeholder="请输入验证码"
            style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" class="pwd_signup" placeholder="设置您的密码" type="password"
            :show-password="true" style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
            <template #append>
              <span style="cursor:pointer;" @click="register()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="agree">
          <span style="font-size:medium;margin-left:100px;">
            <el-checkbox style="transform: scale(1.5);" v-model="registerForm.agree"></el-checkbox>
            &nbsp;&nbsp;我已阅读并同意
            <span style="color:deepskyblue;cursor:pointer;">《服务条款》</span>
            和
            <span style="color:deepskyblue;cursor:pointer;">《隐私协议》</span>
          </span>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import { sendSmsCode, register } from '@/api/user';
export default {
  data() {
    return {
      activeTab: 'login',
      loginForm: {
        phone: '',
        email: '',
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      registerForm: {
        phone: '',
        email: '',
        password: '',
        agree: false
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('请同意条款'));
              else callback(); // 验证通过
            }, trigger: 'change'
          }
        ]
      }
    };
  },
  methods: {
    sendSmsCodeRegister() {
      sendSmsCode({ mobile: this.registerForm.phone, scene: 'ZC' }).then(response => {
        if (response.data.code == 1) this.$message.success('验证码已发送，请注意查收')
      })
    },
    sendSmsCodeLogin() {
      sendSmsCode({ mobile: this.loginForm.phone, scene: 'YZMDL' }).then(response => {
        if (response.data.code == 1) this.$message.success('验证码已发送，请注意查收')
      })
    },
    register() {
      this.$refs.registerFormRef.validate((valid) => {
        if (!valid) return
        register({ account: this.registerForm.phone, password: this.registerForm.password, sms_code: this.registerForm.email, terminal: 0 })
          .then(response => {
            if(response.data.code==1){
              this.$message.success('注册成功')
              setTimeout(() => {
                this.activeTab = "login"
              }, 1000)
              
              // this.loginEmail()
            }
            // console.log(response)
          })
      })
    },
    async loginEmail() {
      this.$refs["loginFormRef"].validate(async (valid) => {
        if (!valid) return
        const data = await this.$store.dispatch('user/loginEmail', { mobile: this.loginForm.phone, code: this.loginForm.email })
        const userInfo = await this.$store.dispatch('user/getInfo')
        if (data.code == 1) {
          localStorage.setItem('userInfo', JSON.stringify(userInfo.data))
          this.$router.push('/store/dashboard')
        }
      })
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
::v-deep .el-form-item__error {
  left: 40px;
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  height: 405px;
  border: solid 3px rgba(177, 110, 249, 1);
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: linear-gradient(0deg,
      rgba(238, 238, 238, 1) 0,
      transparent 100%);
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__item {
  width: 50%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
}

::v-deep .el-tabs__item:nth-child(1) {
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  background: none;
  border-bottom: none !important;
  border-top: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 4px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(2) {
  width: 51%;
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: -3px !important;
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  width: 50.8%;
  background: none;
  border-bottom: none !important;
  border-top: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 3px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: -3px !important;
}

::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 60px;
  font-size: large;
}

::v-deep .email_login .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .email_login .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

::v-deep .email_signup .el-input__inner {
  border-radius: 18px;
}

::v-deep .pwd_signup .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .pwd_signup .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

.tab-label {
  font-size: x-large;
  font-weight: normal;
  color: #333;
}

.active-tab {
  font-weight: bold;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
</style>